import jsPDF from "jspdf";
import "jspdf-autotable";
import QRCode from "qrcode";
import {Style, Section} from "../pages/RegistroVentas/ClasesImpresion";
import { convertStrToJson } from "../Global";
import moment from "moment";
import {loadLogoByRUC, getLoadImage} from "./funcionesGlobales";
import printBlob from "./printBlob";

export async function crearDocPDFServicios(data, extImg = 'png') {
    const { cabecera, detalles, cuotas, empresa } = data;
    
    const doc = new jsPDF({});
    
    const pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
    const pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

    const logo = await loadLogoByRUC(empresa.Ruc, "logo", extImg);
    doc.addImage(logo, "JPEG", 10, 10, 35, 15);

    const EmpresaTittleStyle = new Style(11, "bold", 1.2);
    const EmpresaTittleSection = new Section(doc, 50, 12, EmpresaTittleStyle, 80);
    EmpresaTittleSection.write(empresa.RazonSocial.toUpperCase());

    const EmpresaDataStyle = new Style(7.5, "normal", 1.2);
    const EmpresaDataSection = new Section(doc, 50, EmpresaTittleSection.endY + 2, EmpresaDataStyle, 80);
    EmpresaDataSection.write(empresa.Direccion.toUpperCase());
    EmpresaDataSection.write(empresa.Distrito ? empresa.Distrito.toUpperCase() : "");
    if (empresa.Telefono) EmpresaDataSection.write("TELÉFONO: " + empresa.Telefono);

    const ComprobanteStyle = new Style(11, "bold", 1.5, 'center');
    const ComprobanteSection = new Section(doc, 135, 8, ComprobanteStyle, 65, null, 2);
    ComprobanteSection.write("R.U.C. " + empresa.Ruc, new Style(13, "bold", 1.2, 'center'));
    
    let nombreComprobante = cabecera.TipoComprobante.toUpperCase();
    if (!nombreComprobante.includes("ELECTRÓNICA")) nombreComprobante += " ELECTRÓNICA";
    
    ComprobanteSection.write([
        nombreComprobante,
        cabecera.Serie + " - " + cabecera.NumeroComprobante
    ]);
    ComprobanteSection.drawBox(1);

    const infoStyle = new Style(8, "normal", 1.5);
    const clienteSection = new Section(doc, 10, 40, infoStyle, 115, null, 2);
    clienteSection.write(`CLIENTE:      ${cabecera.razonSocial.toUpperCase()}`);
    clienteSection.write(`RUC:          ${cabecera.numDoc}`);
    clienteSection.write(`DIRECCIÓN:    ${(cabecera.direccionCliente || "").toUpperCase()}`);
    clienteSection.drawBox(1);

    const emisionSection = new Section(doc, 130, 40, infoStyle, 70, null, 2);
    emisionSection.write(`FECHA DE EMISIÓN:`, new Style(8, "bold", 1.5, 'center'));
    emisionSection.write(`${moment(cabecera.FechaEmision).format("DD/MM/YYYY")}`, new Style(8, "normal", 1.5, 'center'));
    emisionSection.drawBox(1);

    const emisionExtraSection = new Section(doc, 130, emisionSection.endY + 2, infoStyle, 70, null, 2);
    emisionExtraSection.write(`TIPO DE MONEDA: ${cabecera.moneda === 'SOL' ? 'SOLES' : 'DOLARES'}`);
    emisionExtraSection.write(`TIPO DE PAGO:   ${cabecera.IdModalidadPago === 1 ? 'CONTADO' : 'CRÉDITO'}`);
    if (cabecera.IdModalidadPago === 2) {
        emisionExtraSection.write(`CUOTAS:         ${cuotas.length}`);
    }
    emisionExtraSection.drawBox(1);

    const startYTabla = Math.max(clienteSection.endY, emisionExtraSection.endY) + 5;
    const itemsFormateados = detalles.map(d => ({
        cantidad: Number(d.Cantidad).toFixed(2),
        descripcion: d.Descripcion,
        precio: Number(d.PrecioVenta).toFixed(2),
        desc: Number(d.Descuento).toFixed(2),
        total: (Number(d.Cantidad) * Number(d.PrecioVenta)).toFixed(2)
    }));

    doc.autoTable({
        body: itemsFormateados,
        startY: startYTabla,
        margin: { left: 10, right: 10 },
        columns: [
            {header: 'CANT.', dataKey: 'cantidad'},
            {header: 'DESCRIPCIÓN', dataKey: 'descripcion'},
            {header: 'PRECIO', dataKey: 'precio'},
            {header: 'DESC.', dataKey: 'desc'},
            {header: 'TOTAL', dataKey: 'total'}
        ],
        headStyles: { 
            fillColor: [255, 255, 255], 
            textColor: [0, 0, 0], 
            fontStyle: 'bold', 
            lineWidth: 0.1, 
            halign: 'center',
            fontSize: 8
        },
        bodyStyles: { fontSize: 8, textColor: [0, 0, 0], lineWidth: 0.1 },
        columnStyles: {
            cantidad: { halign: 'center' },
            descripcion: { cellWidth: 60 },
            precio: { halign: 'right' },
            desc: { halign: 'right' },
            total: { halign: 'right' }
        },
        theme: 'grid'
    });

    let finalY = doc.autoTable.previous.finalY;

    let infoCreditoEndY = finalY;
    if (cabecera.IdModalidadPago === 2 && cuotas.length > 0) {
        doc.setFont("helvetica", "bold");
        doc.setFontSize(9);
        doc.text("INFORMACIÓN DEL CRÉDITO", 10, finalY + 10);
        
        const cuotasTable = cuotas.map((c, i) => [i + 1, Number(c.monto).toFixed(2), moment(c.fecha).format("MM-DD-YYYY")]);
        doc.autoTable({
            body: cuotasTable,
            startY: finalY + 12,
            margin: { left: 10 },
            tableWidth: 100,
            head: [['N° CUOTA', 'MONTO', 'FECHA']],
            headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], fontStyle: 'bold', lineWidth: 0.1, halign: 'center', fontSize: 7 },
            bodyStyles: { fontSize: 7, halign: 'center', lineWidth: 0.1 },
            theme: 'grid'
        });
        infoCreditoEndY = doc.autoTable.previous.finalY;
    }

    const totalsX = 135;
    const totalsWidth = 65;
    const totalStyle = new Style(8, "normal", 1.2, 'right');
    const totalLabelStyle = new Style(8, "normal", 1.2, 'left');

    const totalesTitle = [
        "BASE:",
        "IGV:",
        "TOTAL:",
        "IMPORTE:",
    ];

    const totalesValores = [
        `S/ ${Number(cabecera.Gravadas).toFixed(2)}`,
        `S/ ${Number(cabecera.IGV).toFixed(2)}`,
        `S/ ${Number(cabecera.Total).toFixed(2)}`,
        `S/ ${Number(cabecera.Total).toFixed(2)}`,
    ];

    const totalsLabelsSection = new Section(doc, totalsX, finalY + 5, totalLabelStyle, 35, null, 2);
    totalsLabelsSection.write(totalesTitle);

    const totalsValuesSection = new Section(doc, totalsX + 35, finalY + 5, totalStyle, 30, null, 2);
    totalsValuesSection.write(totalesValores, new Style(8, "bold", 1.2));

    let footerY = Math.max(infoCreditoEndY, totalsLabelsSection.endY) + 5;
    
    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    
    const obsStyle = new Style(8, "normal", 1.2);
    const obsSection = new Section(doc, 10, footerY + 2, obsStyle, 190, null, 2);
    obsSection.write("OBSERVACIÓN:", new Style(8, "bold", 1.2));
    
    obsSection.write("OPERACIÓN SUJETA AL SISTEMA DE PAGO DE OBLIGACIONES TRIBUTARIAS. RESOLUCIÓN NRO. 207-2004 SUNAT.");
    
    if (cabecera.Observacion) {
        obsSection.write(cabecera.Observacion.toUpperCase());
    }
    obsSection.drawBox(1);

    const resSunat = convertStrToJson(cabecera.RespuestaSunat);
    const xmlUrl = (resSunat.xmlFirmado || "").replace("http:", "https:");
    const cdrUrl = (resSunat.cdrZip || "").replace("http:", "https:");

    if (xmlUrl) {
        const qrXmlImage = await getLoadImage(await QRCode.toDataURL(xmlUrl));
        doc.addImage(qrXmlImage, "PNG", 10, obsSection.endY + 5, 25, 25);
    }
    
    if (cdrUrl) {
        const qrCdrImage = await getLoadImage(await QRCode.toDataURL(cdrUrl));
        doc.addImage(qrCdrImage, "PNG", 40, obsSection.endY + 5, 25, 25);
    }

    return doc;
}

export const printA4Servicios = async (data, extImg = 'png', doPrint = true) => {
    const doc = await crearDocPDFServicios(data, extImg);
    if (doPrint) {
        doc.autoPrint();
        const bloburl = doc.output("bloburl");
        printBlob(bloburl);
    } else {
        doc.save(`${data.cabecera.Serie}-${data.cabecera.NumeroComprobante}.pdf`);
    }
};

export default printA4Servicios;
